import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { profile } from "../data/portfolio";

const links = [
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Projects" },
  { id: "skills", label: "Skills" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-[background-color,backdrop-filter,border-color] duration-300 ${
        scrolled
          ? "bg-[#06030f]/70 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a
          data-testid="nav-brand"
          href="#about"
          className="font-mono text-sm tracking-widest text-white/90 hover:text-purple-300 transition-colors"
        >
          <span className="text-purple-400">~/</span>riya-gupta
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              href={`#${l.id}`}
              className="px-3 py-2 text-sm text-white/70 hover:text-white transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid="nav-resume-btn"
            href={profile.resumeUrl}
            target="_blank"
            rel="noreferrer"
            download="Riya-Gupta-Resume.pdf"
            className="ml-2 px-4 py-2 rounded-md bg-purple-600 hover:bg-purple-500 text-white text-sm font-medium transition-colors"
          >
            Resume
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-white/80 hover:text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-[#06030f]/95 backdrop-blur-xl border-t border-white/5"
        >
          <div className="max-w-6xl mx-auto px-5 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md text-white/80 hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
            <a
              data-testid="nav-mobile-resume"
              href={profile.resumeUrl}
              target="_blank"
              rel="noreferrer"
              download="Riya-Gupta-Resume.pdf"
              className="mt-1 px-4 py-3 rounded-md bg-purple-600 text-white text-center font-medium"
            >
              Download Resume
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
